import { render, staticRenderFns } from "./JeecgEditableTableExample.vue?vue&type=template&id=6c1b675a&scoped=true&"
import script from "./JeecgEditableTableExample.vue?vue&type=script&lang=js&"
export * from "./JeecgEditableTableExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b675a",
  null
  
)

export default component.exports